<template>
  <div class="container">

    <div class="videoPlayer">
      <div class="overlay"></div>
      <!-- <div class="row justify-content-center">
          <div class="col-12"> -->
      <!-- <div class="m-auto"> -->
      <!-- <video autoplay="autoplay" loop="loop" class="img-fluid" style="object-fit: cover;">
                <source src="/static/assets/images/a.mp4">
              </video> -->
      <!-- <video id="player" class="video-js vjs-default-skin" width="640" height="360" controls autoplay loop muted preload="none"
              poster="https://vjs.zencdn.net/v/oceans.png">
              <source src="https://vjs.zencdn.net/v/oceans.mp4?480" type='video/mp4' label='SD' res='480' />
              <source src="https://vjs.zencdn.net/v/oceans.mp4?1080" type='video/mp4' label='HD' res='1080' />
              <source src="https://vjs.zencdn.net/v/oceans.mp4?2160" type='video/mp4' label='4k' res='2160' />
              <source src="https://vjs.zencdn.net/v/oceans.mp4?144" type='video/mp4' label='phone' res='144' />
              </video> -->
      <!-- </div>  -->
      <!-- </div>
        </div> -->
      <div class="videoInfo">

        <div
          v-if="courseDetails.contentId != undefined && courseDetails.contentId.length != 0"
          class="videoData"
        >
          <div class="row text-center">
            <div class="col-12">
              <h1 v-if="courseDetails.title!= undefined && courseDetails.title!= null">{{ courseDetails.title }}</h1>
              <div v-if="isLoggedIn">
                <div v-if="courseDetails.contentId != undefined && $store.getters.getItemPurchasedStatus(courseDetails.contentId) != undefined && $store.getters.getItemPurchasedStatus(courseDetails.contentId)!= null && $store.getters.getItemPurchasedStatus(courseDetails.contentId)">
                  <!-- show purchase date & expiry Date -->
                  <div class="row justify-content-between">
                    <div
                      class="col"
                      v-if="$store.getters.getItemPurchasedDates({'id': courseDetails.contentId, 'type': courseDetails.type }).expiryDate != undefined && $store.getters.getItemPurchasedDates({'id': courseDetails.contentId, 'type': courseDetails.type }).expiryDate != null"
                    >
                      <h5>{{$store.getters.getItemPurchasedDates({'id': courseDetails.contentId, 'type': courseDetails.type }).expiryDate.split("/").join("-")}}</h5>
                      <p class="sub-text">Your course expires on</p>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <div
                class="subtitle"
                v-if="courseDetails.description != undefined && courseDetails.description != null"
              > {{courseDetails.description}}</div>
            </div>
          </div>

          <div class="row text-center course-details-row align-items-center justify-content-center">
            <div
              class="col-lg-2"
              v-if="courseDetails.enrolledCount != undefined && courseDetails.enrolledCount != null"
            >
              <h5 class="title">{{ courseDetails.enrolledCount }}</h5>
              <p class="sub-text">Students enrolled</p>
            </div>
            <div
              class="col-lg-2"
              v-if="courseDetails.skills != undefined && courseDetails.skills != null && courseDetails.skills.length > 0"
            >
              <h5>{{courseDetails.skills.join(',')}}</h5>
              <p class="sub-text text-center">Skill Level</p>
            </div>
            <div class="col-lg-3 rating-star">
              <!-- if user is logged in and item subscription had not expired then allow user to rate the content -->
              <div v-if="isLoggedIn && $store.getters.getItemSubscriptionStatus({'id': courseDetails.contentId, 'type': courseDetails.type}) != undefined && $store.getters.getItemSubscriptionStatus({'id': courseDetails.contentId, 'type': courseDetails.type})!= null && $store.getters.getItemSubscriptionStatus({'id': courseDetails.contentId, 'type': courseDetails.type})">
                <div v-on:click="showRating(courseDetails.contentId)">
                  <star-rating
                    :rating="courseDetails.rating"
                    v-bind:increment="0.5"
                    @rating-selected="setRating"
                    v-bind:max-rating="5"
                    inactive-color="#96999a"
                    active-color="#ffc000"
                    :star-size="22"
                  >
                  </star-rating>
                </div>
                <div class="sub-text"> {{$t('common.labels.your_Rating')}}</div>
              </div>
              <!-- if user is not logged in or user subscription had expired user can't rate the content -->
              <div v-else>
                <star-rating
                  :rating="courseDetails.rating"
                  :read-only=true
                  v-bind:increment="0.5"
                  @rating-selected="setRating"
                  v-bind:max-rating="5"
                  inactive-color="#96999a"
                  active-color="#ffc000"
                  v-bind:star-size="15"
                >
                </star-rating>
                <div class="sub-text">{{$t('common.labels.OVERALL_RATING')}}</div>
              </div>

            </div>
            <div
              class="col-lg-2"
              v-if="courseDetails.totalNumberofLO != undefined && courseDetails.totalNumberofLO != null && courseDetails.totalNumberofLO !=0"
            >
              <h5 class="title">{{ courseDetails.totalNumberofLO }}</h5>
              <p class="sub-text">Lectures</p>
            </div>
            <div
              class="col-lg-2"
              v-if="courseDetails.duration != undefined && courseDetails.duration != null && courseDetails.duration != 0"
            >
              <h5 class="title">{{ courseDetails.duration +'H'}} </h5>
              <p class="sub-text">Course duration</p>
            </div>
            <div class="w-100"></div>
            <div class="col-auto">
              <div v-if="courseDetails.languageId != undefined && displayLanguage(courseDetails.languageId)!= undefined && displayLanguage(courseDetails.languageId) != null">
                <h5>{{displayLanguage(courseDetails.languageId)}}</h5>
                <p class="sub-text">Available in</p>
              </div>
            </div>
            <div class="w-100"></div>
            <!-- show price if user had not purchased or course is not expired -->
            <div v-if="courseDetails.contentId != undefined && $store.getters.getItemPurchasedStatus(courseDetails.contentId) != undefined && $store.getters.getItemPurchasedStatus(courseDetails.contentId)!= null && $store.getters.getItemPurchasedStatus(courseDetails.contentId)">
              <div class="col-auto">
                <div v-if="courseDetails.contentId != undefined && $store.getters.getItemPurchasedStatus(courseDetails.contentId) != undefined && $store.getters.getItemPurchasedStatus(courseDetails.contentId)!= null && $store.getters.getItemPurchasedStatus(courseDetails.contentId)">
                  <h5>{{courseDetails.price}} {{courseDetails.price > 1 ? 'Point' :'Points'}}</h5>
                  <p class="sub-text">Course costs</p>
                </div>
              </div>

            </div>
            <div class="col-12">
              <!-- action  if user is logged in-->
              <div v-if="isLoggedIn">
                <!-- check for course Subscription expiry -->
                <div
                  v-if="$store.getters.getItemSubscriptionStatus({'id': courseDetails.contentId, 'type': courseDetails.type})!= undefined && $store.getters.getItemSubscriptionStatus({'id': courseDetails.contentId, 'type': courseDetails.type})!= null && $store.getters.getItemSubscriptionStatus({'id': courseDetails.contentId, 'type': courseDetails.type})"
                  class="pb-3"
                >

                  <button
                    class='btn btn-blue-no-bg btn-blk'
                    @click="goToCourse(courseDetails)"
                  >GO TO COURSE</button>
                  <!-- <button v-else-if="cartAdd($store.getters.getCourseDetails.contentId)" class='btn btn-blue-no-bg btn-blk'>ADDED TO CART></button> -->
                </div>
                <!-- if user had not Purchased the course or course is Expired  -->
                <div
                  v-else-if="featureStatusInfoList&&featureStatusInfoList.cart"
                  class="pb-3"
                >
                  <button
                    v-if="$store.getters.itemPresentInCartStatus(courseDetails.contentId)"
                    class='btn btn-blue-no-bg btn-blk'
                  >ADDED TO CART</button>
                  <button
                    v-else
                    @click="addToCart(courseDetails.contentId)"
                    class="btn btn-blk btn-blue"
                  >ADD TO CART</button>
                </div>
              </div>
              <div v-else-if="featureStatusInfoList&&featureStatusInfoList.cart">
                <div class="col-lg-12">
                  <p class="sub-text">Price</p>
                  <h5>{{courseDetails.price}} {{courseDetails.price > 1 ? 'Point' :'Points'}}</h5><br />
                  <button
                    @click="goToLogin()"
                    class="btn btn-blk btn-blue"
                  >ADD TO CART</button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div
          v-else
          class="noticemsg"
        >
          SOMETHING WENT WRONG
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import axios from "axios";
// import videojs from 'video.js'
import "videojs-resolution-switcher";
// vue.require(StarRating)
export default {
  name: "bannerVideo",
  components: { StarRating },
  props: ["contentId"],
  data() {
    return {
      courseDetails: {},
      // show: false,
      rating: 0,
      purchaseDate: null,
      expiryDate: null
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.getIsLoggedIn;
    }
  },
  methods: {
    goToLogin() {
      // window.MKCLAPI.login()
      this.$root.$emit("bv::show::modal", "login");
    },
    displayLanguage(langArr) {
      // alert(JSON.stringify(langArr))
      // console.log(JSON.stringify(langArr))
      var language = "";
      for (let i = 0; i < langArr.length; i++) {
        // alert(langArr[i])
        if (langArr[i] === "1") {
          if (language.length !== 0) {
            language = language + ", English";
          } else {
            language = "English";
          }
        } else if (langArr[i] === "2") {
          if (language.length !== 0) {
            language = language + ", Hindi";
          } else {
            language = "Hindi";
          }
        } else if (langArr[i] === "3") {
          if (language.length !== 0) {
            language = language + ", Marathi";
          } else {
            language = "Marathi";
          }
        }
      }
      return language;
    },
    goToCourse(course) {
      this.$store.dispatch("checkExpiryDateForCO", course);
    },
    showRating(contentID) {
      if (this.isLoggedIn) {
        axios
          .post("/r/rating/addratingdata", {
            profileId: this.$store.getters.getProfileDetails.profileId,
            contentId: contentID,
            rating: this.rating
          })
          .then(response => {
            this.$toasted.success("Rating added successfully");
            this.$store.dispatch("setCurrentCourse", response.data);
          })
          .catch(error => {
            alert(error);
          });
      }
    },
    addToCart(id) {
      if (this.isLoggedIn) {
        this.$store
          .dispatch("addCartData", {
            itemId: id,
            profileId: this.$store.getters.getProfileDetails.profileId,
            cartId: this.$store.getters.getCartData.cartId
          })
          .then(
            response => {
              this.$toasted.success(
                this.$t("common.alerts.CART_ADDED_SUCCESS")
              );
            },
            error => {
              console.log("error in adding item to cart", error);
            }
          );
      } else {
        window.MKCLAPI.login();
      }
    },
    setRating: function(rating) {
      this.rating = rating;
    },
    cartAdd(itemId) {
      for (var j = 0; j < this.$store.getters.getCartData.items.length; j++) {
        if (this.$store.getters.getCartData.items[j].itemId === itemId) {
          return true;
        }
      }
      return false;
    }
  },
  mounted: function() {
    return new Promise((resolve, reject) => {
      // alert(this.contentId)
      axios
        .post("o/getlodetails", { contentId: this.contentId })
        .then(response => {
          this.courseDetails = response.data;
          // this.show = true
          // console.log(JSON.stringify(this.courseDetails))
          /*   var player = videojs('player', {
              plugins: {
                videoJsResolutionSwitcher: {
                  default: 'low',
                  dynamicLabel: true
                }
              }
            })
            // console.log('=======================>', document.getElementById('test'))
            if (player != null) {
              resolve()
            } */
        })
        .catch(err => {
          console.log("error in fetching course details : ", err);
          reject();
        });
    });
  }
};
</script>
<style lang="scss">
@import "../../../static/assets/styles/scss/variables.scss";
@import "../../../node_modules/video.js/dist/video-js.css";
@import "../../../node_modules/videojs-resolution-switcher/lib/videojs-resolution-switcher.css";

.videoPlayer {
  position: relative;
  min-height: 600px;
  text-align: center;
  /*left: 7.5%;
  width: 85%;*/
  border-radius: 5px;
  background-attachment: scroll;
  overflow: hidden;
  box-shadow: 0px 10px 35px rgba(0, 0, 0, 0.25);
  video {
    min-width: 100%;
    min-height: 100%;
    position: relative;
    z-index: 1;
    margin-bottom: -6px;
  }
  .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 2;
    background: linear-gradient(
      to right,
      rgb(89, 184, 228) 5%,
      rgb(110, 99, 197) 95%
    );
  }
  .videoInfo {
    position: relative;
    z-index: 5;
    padding: 70px 0px 80px;
    /*position: absolute;
    width: 100%;
    top: -15px;
    bottom: 0;*/
    background-color: transparent;
    .videoData {
      h1 {
        font-family: $opensans;
        font-size: 36px;
        line-height: 42px;
        margin-bottom: 20px;
        font-weight: 300;
      }
      h5 {
        font-weight: 300;
        font-size: 18px;
      }
      .subtitle {
        font-family: $opensans;
        padding: 10px 0 60px;
        width: 88%;
        margin: 0 auto;
        font-size: 14px;
        line-height: 24px;
        color: rgba(#fff, 0.9);
      }
      .sub-text {
        margin-bottom: 0;
        opacity: 0.8;
      }
      color: #fff;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      /*height: 100%;
      width: 100%;
      position: absolute;
      top: 9%;
      left: 0px;
      z-index: 2;*/
      .videoicon {
        font-size: 50px;
        opacity: 0.5;
        padding-top: 0px;
        &:hover {
          opacity: 1;
          cursor: pointer;
        }
      }
      .fa-language,
      .fa-circle,
      .fa-circle-thin,
      .fa-star,
      .fa-star-half-o {
        font-size: 16px;
        vertical-align: middle;
      }
    }
  }

  .course-details-row {
    // margin-bottom: 20px;
    > [class*="col"] {
      margin-bottom: 40px;
    }
  }
  .rating-star {
    .vue-star-rating-star {
      svg {
        height: 30px;
      }
    }
  }
}
@media only screen and (min-width: 1400px) {
  .videoPlayer {
    width: 75%;
    left: 12.5%;
    .videoInfo {
      .videoData {
        top: 14%;
      }
    }
  }
}
.ratingText {
  color: white;
  font-size: 15px;
  font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/components/course/bannerVideo.vue?96db09c4